
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import HelpButton from "../header/HelpButton";
import LogInOutButton from "../header/LogInOutButton";
import LanguagePicker from "../header/LanguagePicker";
import GroupsManagementButton from "../header/GroupsManagementButton";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        mainHeader: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            "&>div": {
                display: "flex",
                height: "100%",
                justifyContent: "flex-end",
                alignItems: "center",
                flexGrow: "10",
                justifyItems: "end",

                "&>div": {
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    "& .MuiIconButton-label": {
                        margin: "0 1rem",
                    },

                    "& button": {
                        color: "#212121",
                        backgroundColor: "#455681",
                        height: "3rem",
                        padding: "0 1rem",
                    },
                },
            },
            "& .MuiIconButton-label": {
                height: "1.5rem!important",
            },
            "& .title": {
                display: "flex",
                alignItems: "center",
                margin: "0",
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "1.25rem",
                lineHeight: "1.6875rem",
                color: "#212121",
                flexGrow: "10",
            },

            "& .logout": {
                color: "#212121",
                width: "3rem",
                height: "3rem",
            },

            "& .login": {
                color: "#212121",
            },
            "& .ordersCount": {
                border: "1px solid #757575",
                boxSizing: "border-box",
                borderRadius: "0.375rem",
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "1.125rem",
                lineHeight: "1.5625rem",
                padding: "0.125rem 0.625rem",
                marginLeft: "0.625rem",
                display: "flex",
                alignItems: "center",
                textAlign: "center",
                color: "#757575",
            },
            '& button': {
                "&:hover": {
                    backgroundColor: "#455681",
                },
                "&:active": {
                    backgroundColor: "unset!important",
                },
            },
            '& a': {
                height: "1.5rem!important",
                "&>svg": {
                    height: "1.5rem!important",
                },
            },
        },

        "@media (min-width: 960px)": {
            mainHeader: {
                width: "calc(100% - 324px)",
                paddingLeft:"1%",
                paddingRight: "24px",
                display: "flex",
                alignItems: "center",
                right: "0",
                position: "fixed",
            },
        },
    })
);

export function OverviewHeader() {
    const { t } = useTranslation();
    const isSuperUser = useSelector((state: IReduxAppState) => state.merchant?.superuser);
    const classes = useStyles();

    const titleAlt = useSelector(
        (state: IReduxAppState) => state.sidebar.position.text
    );

    return <div className={classes.mainHeader} >
        <>
            <h3 className="title">
                {t(titleAlt)}
            </h3>

            <div>
                <HelpButton />
                <LanguagePicker />
                {isSuperUser && <GroupsManagementButton/>}
                <LogInOutButton />
            </div>
        </>
    </div>

}